<template>
  <a-modal
    :title="title"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-item
        v-show="false"
        label="id"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="['id']"
          :disabled="editable || showable"
        />
      </a-form-item>
      <a-form :form="form">
        <a-form-item
          label="主键"
          :hidden="true"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :disabled="showable"
            v-decorator="['id', {rules: [{required: false, message: '请输入id'}]}]" />
        </a-form-item>
        <a-form-item
          label="考勤小组名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            placeholder="请输入考勤小组名称"
            :disabled="showable"
            v-decorator="['name', {rules: [{required: true, message: '请输入考勤小组名称'}]}]" />
        </a-form-item>
<!--        label="考勤员id，关联用户表id"-->
        <a-form-item
          label="考勤员"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            placeholder="请选择考勤员"
            showSearch
            :filterOption="filterOption"
            :disabled="showable"
            :options="attendanceList"
            v-decorator="['leaderId', {rules: [{required: true, message: '请选择考勤员'}]}]"
          />
<!--            <a-select-option value="0">张三</a-select-option>-->
<!--            <a-select-option value="1">李四</a-select-option>-->
<!--            <a-select-option value="2">王五</a-select-option>-->
<!--          </a-select>-->

        </a-form-item>
<!--        label="项目id，小组类型为公司小组时此字段为空，为项目小组时不为空。关联项目表project_info id"-->
        <a-form-item
          label="项目"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            placeholder="请选择项目"
            :filterOption="filterOption"
            :disabled="showable"
            :options="projects"
            v-decorator="['projectId', {rules: [{required: true, message: '请选择项目'}]}]">

          </a-select>
        </a-form-item>

      </a-form>
    </a-spin>
    <template slot="footer" >
      <div v-show="editable || addable">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="confirmLoading" type="primary" @click="handleOk">保存</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { FormMixin } from '@/mixins/FormMixin'
import { getObj, addObj, putObj, attendProject } from '@/api/common/AttendGroup'
import { dropDownByCode } from '@/api/sys/user'

export default {
  name: 'AttendGroupAddOrUpdate',
  mixins: [FormMixin],
  data () {
    return {
      confirmLoading: false,
      form: this.$form.createForm(this),
      showable: false,
      attendanceList: [],
      projects: [],
      purchaserQuery: {
        roleCode: 'sx_attend_manager'
      }
    }
  },
  methods: {
    edit (id, type) {
      this.visible = true
      const { form: { setFieldsValue, resetFields } } = this
      dropDownByCode(this.purchaserQuery).then(res => {
        this.attendanceList = res.data
      })
      attendProject().then(res => {
        this.projects = res.data
      })
      if (['edit', 'show'].includes(type)) {
        this.confirmLoading = true
        getObj(id).then(res => {
          const record = res.data
          this.confirmLoading = false
          this.$nextTick(() => {
            setFieldsValue(pick(record, ['id', 'name', 'leaderId', 'projectId']))
          })
        })
      } else {
        resetFields()
      }
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    handleOk () {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.confirmLoading = true
          try {
            if (this.type === 'add') {
              await addObj(values)
            } else if (this.type === 'edit') {
              await putObj(values)
            }
            setTimeout(() => {
              this.confirmLoading = false
              this.$emit('ok')
              this.handleCancel()
            }, 1500)
          } catch (e) {
            this.confirmLoading = false
            this.$message.error(e.msg)
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
